<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Group Management</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">In the section “Group Management” you can manage the groups.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">The meaning of groups</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">A group is important to define the visibility of challenges.
Infact, a user with role Customer/Customer+chat/admin can access (and so edit) only the challenges created by a user belonging to its own group.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">How to create a group</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To create a group, click on the blue "New group" button, write an identifying name and click on the green "Submit" button.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">How to associate users to groups</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To associate a user to a group, go to the "User Management" page and click on the pencil icon on the corresponding line.
In the "Group" field, choose from the drop-down menu the group to which you wish to associate the user.


</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "GroupManagementHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_paragraph{
        font-size: 22px;
        font-weight: bold;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>